module.exports = __webpack_public_path__ + "static/cdsdqrmyy-b663ec12eee88b69bf8fd87955a8af01.jpg";